import { useLiveQuery } from 'dexie-react-hooks';
import ABTest from '../../model/abTest';
import ABTestingService from './abTestingService';

export function useGetABTestValue(testId: string): number | null {
  const abTest: ABTest | undefined = useLiveQuery(() => ABTestingService.getTestValueQuery(testId));

  const testValue = getABTestGroup(abTest);
  return testValue;
}

export async function getABTestValue(testId: string): Promise<number | null> {
  const abTest = await ABTestingService.getABTest(testId);

  const testValue = getABTestGroup(abTest);
  return testValue;
}

export function useIsABTestActive(testId: string) {
  const abTest: ABTest | undefined = useLiveQuery(() => ABTestingService.getTestValueQuery(testId));
  return isTestActive(abTest);
}

export async function getIsABTestActive(testId: string) {
  const abTest = await ABTestingService.getABTest(testId);

  const isActive = isTestActive(abTest);

  return isActive;
}

function getABTestGroup(test: ABTest | undefined): number | null {
  if (!test) {
    return null;
  }
  const testValue = extractGroupFromValue(test.test_value);
  return testValue;
}

function isTestActive(test: ABTest | undefined): boolean {
  const testValue = getABTestGroup(test);
  return !!testValue;
}

function extractGroupFromValue(testValue: string | undefined): number | null {
  if (!testValue) {
    return null;
  }
  // Assumes groupName is in the format "GROUP_X" where X is the group number
  const prefixLength = 'GROUP_'.length;
  const groupNumberStr = testValue.substring(prefixLength); // Extract the part after "GROUP_"
  const groupNumber = parseInt(groupNumberStr, 10); // Convert the string to an integer
  return isNaN(groupNumber) ? null : groupNumber; // Return null if the conversion fails
}
